import * as React from 'react';
import './ReturnsMobile.scss';
import TabsV from 'src/components/common/TabsV';
import EligibleTab from '../EligibleTab';
import StatusTab from '../StatusTab';
// import DamagedTab from '../DamagedTab';
// import MisshipmentsTab from '../MisshipmentsTab';
import { IEligibleResponse } from 'src/services/returns/typings';
import { IRmaModalData, IToggleModalOptions } from '../../ReturnsView';

interface IReturnsMobileProps {
  currentTab: number;
  selectTab: (index: number) => void;
  eligibleData: IEligibleResponse;
  handlePaginationEligible: (type: string) => void;
  handleSortItemsEligible: (option: string) => void;
  sortEligible: string[];
  setSortEligible: (values: string[]) => void;
  selectedTypeOfItem: string;
  selectedTypeOfItemStatus: string;
  handleSelectedTypeOfItem: (type: any) => void;
  handleSelectedTypeOfItemStatus: (type: any) => void;
  selectedDates: any;
  setSelectedDates: (date: any) => void;
  handleDateChange: (date: any) => void;
  handleClickSearch: (searchBy: string, query: string) => void;
  handleClickSearchStatus: (searchBy: string, query: string) => void;
  handleShowCartModal: (status: boolean) => void;

  handlePaginationStatus: (type: string) => void;
  handleSortItemsStatus: (option: string) => void;
  sortStatus: string[];
  handleShowRmaModal: (state: boolean, rmaModalData: IRmaModalData) => void;
  setSelectedReturnToDelete: (id: string) => void;
  filter: string;
  setFilter: (value: string) => void;
  handleOpenBarcodeModal: (rmaNumber: string,upsResponseData:any[]) => void;
  showCounter: boolean;
  forItem: string;
  showCounterStatus: boolean;
  forItemStatus: string;
  clearStatusFilters: () => void;
  clearEligibleFilters: () => void;
  toggleModalOptions: IToggleModalOptions;
  t?: any;
  handleDesktopPaginationEligible?(event: any): void;
  handleDesktopPaginationStatus?(event: any): void;
  handlePageSizeChangeEligible?(event: any): void;
  handlePageSizeChangeStatus?(event: any): void;
  handleMenuItemClick: (event: any, index:number) => void;
  handleMenuItemClickReturnStatus: (event: any, index:number) => void;
}

const ReturnsMobile: React.FC<IReturnsMobileProps> = props => {
  const {
    currentTab,
    selectTab,
    eligibleData,
    handlePaginationEligible,
    handleSortItemsEligible,
    sortEligible,
    setSortEligible,
    selectedTypeOfItem,
    selectedTypeOfItemStatus,
    handleSelectedTypeOfItem,
    handleSelectedTypeOfItemStatus,
    selectedDates,
    setSelectedDates,
    handleDateChange,
    handleClickSearch,
    handleClickSearchStatus,
    handleShowCartModal,

    handlePaginationStatus,
    handleSortItemsStatus,
    sortStatus,
    handleShowRmaModal,
    setSelectedReturnToDelete,
    filter,
    setFilter,
    showCounter,
    forItem,
    showCounterStatus,
    forItemStatus,
    clearEligibleFilters,
    clearStatusFilters,
    toggleModalOptions,
    t,
    handleDesktopPaginationEligible,
    handlePageSizeChangeEligible,
    handleDesktopPaginationStatus,
    handlePageSizeChangeStatus,
    handleMenuItemClick,
    handleMenuItemClickReturnStatus
  } = props;

  const renderEligibleTab = () => {
    return (
      <EligibleTab
        handlePagination={handlePaginationEligible}
        eligibleData={eligibleData}
        handleSortItems={handleSortItemsEligible}
        sortBy={sortEligible}
        selectedTypeOfItem={selectedTypeOfItem}
        handleSelectedTypeOfItemChange={handleSelectedTypeOfItem}
        selectedDates={selectedDates}
        setSelectedDates={setSelectedDates}
        handleDateChange={handleDateChange}
        handleClickSearch={handleClickSearch}
        setSortEligible={setSortEligible}
        handleShowCartModal={handleShowCartModal}
        showCounter={showCounter}
        forItem={forItem}
        handleChangeTab={selectTab}
        clearFilters={clearEligibleFilters}
        toggleModalOptions={toggleModalOptions}
        handleDesktopPaginationEligible={handleDesktopPaginationEligible}
        handlePageSizeChangeEligible={handlePageSizeChangeEligible}
        handleMenuItemClick={handleMenuItemClick}
      />
    );
  };

  const renderStatusTab = () => {
    return (
      <StatusTab
        handlePagination={handlePaginationStatus}
        handleSortItemsStatus={handleSortItemsStatus}
        sortBy={sortStatus}
        handleShowRmaModal={handleShowRmaModal}
        selectedTypeOfItem={selectedTypeOfItemStatus}
        handleSelectedTypeOfItemChange={handleSelectedTypeOfItemStatus}
        handleClickSearch={handleClickSearchStatus}
        setSortEligible={setSortEligible}
        setSelectedReturnToDelete={setSelectedReturnToDelete}
        filter={filter}
        setFilter={setFilter}
        showCounter={showCounterStatus}
        forItem={forItemStatus}
        clearFilters={clearStatusFilters}
        clearEligibleFilters={clearEligibleFilters}
        handleDesktopPaginationStatus={handleDesktopPaginationStatus}
        handlePageSizeChangeStatus={handlePageSizeChangeStatus}
        handleMenuItemClickReturnStatus={handleMenuItemClickReturnStatus}
      />
    );
  };

  // const renderDamagedTab = () => {
  //   return <DamagedTab />;
  // };

  // const renderMisshipmentsTab = () => {
  //   return <MisshipmentsTab />;
  // };

  return (
    <div className="rp-returns-mobile">
      <div className="rp-returns-mobile-tabs">
        <TabsV
          title={t('myReturns.breadCrumbTitle')}
          currentTab={currentTab}
          selectTab={selectTab}
          tabTitles={[
            {
              id: 1,
              name: `${t('myReturns.eligibleReturns')}`
            },
            {
              id: 2,
              name: `${t('myReturns.returnStatus')}`
            }
            // {
            //   id: 3,
            //   name: `${t('myReturns.damageOrDefective')}`
            // },
            // {
            //   id: 4,
            //   name: `${t('myReturns.misShipments')}`
            // }
          ]}
          tabContents={[
            renderEligibleTab(),
            renderStatusTab()
            // renderDamagedTab(),
            // renderMisshipmentsTab()
          ]}
        />
      </div>
    </div>
  );
};

export default ReturnsMobile;
